import { render, staticRenderFns } from "./editEvection.vue?vue&type=template&id=ad946fb4&scoped=true"
import script from "./editEvection.vue?vue&type=script&lang=js"
export * from "./editEvection.vue?vue&type=script&lang=js"
import style0 from "./editEvection.vue?vue&type=style&index=0&id=ad946fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad946fb4",
  null
  
)

export default component.exports